// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import BusinessQueueController from "./business_queue_controller"
application.register("business-queue", BusinessQueueController)

import BusinessMapController from "./business_map_controller"
application.register("business-map", BusinessMapController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FingerprintController from "./fingerprint_controller"
application.register("fingerprint", FingerprintController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import QueueEntryController from "./queue_entry_controller"
application.register("queue-entry", QueueEntryController)

import QueueProximityController from "./queue_proximity_controller"
application.register("queue-proximity", QueueProximityController)

import QueueStatusController from "./queue_status_controller"
application.register("queue-status", QueueStatusController)

import RecaptchaRefreshController from "./recaptcha_refresh_controller"
application.register("recaptcha-refresh", RecaptchaRefreshController)

import SeatPickerController from "./seat_picker_controller"
application.register("seat-picker", SeatPickerController)
